// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YqFMpE_aSxa4m7g7oLd8{white-space:normal;word-break:break-word;overflow-wrap:break-word}`, "",{"version":3,"sources":["webpack://./src/components/reports/pathTooltip.scss"],"names":[],"mappings":"AAAA,sBACI,kBAAA,CACA,qBAAA,CACA,wBAAA","sourcesContent":[".pathTooltip {\n    white-space: normal;\n    word-break: break-word;\n    overflow-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pathTooltip": `YqFMpE_aSxa4m7g7oLd8`
};
export default ___CSS_LOADER_EXPORT___;
